export default "__VITE_ASSET__DE$OK_Ch__"